
import * as modals from "../../../lib/modals";
import Component from "vue-class-component";
import { getModule } from "vuex-module-decorators";
import InventoryModule from "@/store/modules/barcodeSystem/inventory";
import ModalMixin from "./mixin";
import BulkInventoryItemHeader from "@/components/barcodeSystem/inventory/BulkInventoryItemHeader.vue";
import BulkInventoryItemLocationList from "@/components/barcodeSystem/inventory/BulkInventoryItemLocationList.vue";
import notifications from "@/lib/notifications";

const inventoryModuleState = getModule(InventoryModule);

@Component({
  name: modals.bulkInventoryItemViewModal,
  components: {
    BulkInventoryItemHeader,
    BulkInventoryItemLocationList
  }
})
export default class BulkInventoryItemViewModal extends ModalMixin {
  loadingComplete: boolean = false;
  

  async load() {
    this.loadingComplete = false;
    this.show();
    try
    {
      await inventoryModuleState.loadBulkInventoryItem(this.selectedItem.id);
      await inventoryModuleState.getOtherBulkInventoryItems();
    } catch (ex) {
      notifications.error("Failed to load bulk inventory", "Failed to load bulk inventory item.", ex);
      this.hideModal();
    }
    this.loadingComplete = true;
  }

  reset() {
    this.loadingComplete = false;
  }
}
